import { mdiCalendar } from "@mdi/js";

const arbitrageNav = [
  {
    title: "Acquisition - Campagne",
    icon: mdiCalendar,
    children: [
      {
        title: "Campaign Manager",
        resource: "arbitrage_campaign",
        action: "manage",
        children: [
          {
            title: "Campaign Creator",
            to: "campain-main",
            resource: "arbitrage_campaign",
            action: "manage",
          },
          {
            title: "Campaign Tracker",
            to: "campain-tracker",
            resource: "arbitrage_campaign",
            action: "manage",
          },
        ],
      },

      {
        title: "Redirect Link",
        to: "campaign-redirect",
        resource: "arbitrage_campaign",
        action: "manage",
      },
      {
        title: "Crawlers",
        to: "acquisition-crawlers",
        resource: "arbitrage_campaign",
        action: "manage",
      },
      {
        title: "Daily Report",
        ressource: "arbitrage_campaign",
        action: "manage",
        children: [
          {
            title: "Daily Report",
            to: "daily-report",
            resource: "arbitrage_campaign",
            action: "manage",
          },
          {
            title: "Daily Report - Config",
            to: "daily-report-config",
            resource: "arbitrage_campaign",
            action: "manage",
          },
          {
            title: "Daily Report - Utms",
            to: "daily-report-utms",
            resource: "arbitrage_campaign",
            action: "manage",
          },
        ],
      },
      {
        title: "UTM Content",
        resource: "arbitrage_campaign",
        action: "manage",
        children: [
          {
            title: "UTM Content - Report",
            to: "utm-content",
            resource: "arbitrage_campaign",
            action: "manage",
          },
          {
            title: "UTM Content - Gestion",
            to: "utm-content-whitelist",
            resource: "arbitrage_campaign",
            action: "manage",
          },
        ],
      },
    ],
  },
];

export default arbitrageNav;
